import ouiBase from '@goldwasserexchange/oui';

export const GetComponentKeyByElementPrimaryKey = (props: { data: Record<string, Record<string, any>>, valueKey: string }) => {
  const { data, valueKey } = props;
  const primaryKey = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  return data[primaryKey][valueKey];
};
